import {makeObservable, observable, action} from "mobx";
import {Api} from "modules/utils/Api";
import {ApiModel} from "modules/stores/Base/ApiModel";
import {IApiResponse} from "modules/types";

export interface IProfile {
	terms: null | boolean;
	isNotificationsEnabled: null | boolean;
	acceptedAt: null | boolean;
}

export interface IProfileUpdate {
	terms: boolean;
	sponsorOptIn: boolean;
	marketingEmails: boolean;
}

type TResponse = {
	profile: IProfile;
};

export class Profile extends ApiModel<IApiResponse<TResponse>> {
	@observable public terms: null | boolean = null;
	@observable public isNotificationsEnabled: null | boolean = null;
	@observable public acceptedAt: null | boolean = null;

	constructor() {
		super(Api.Profile.get);
		makeObservable(this);
	}

	protected performResponse({success}: IApiResponse<TResponse>): void {
		this.terms = success.profile.terms;
		this.isNotificationsEnabled = success.profile.isNotificationsEnabled;
		this.acceptedAt = success.profile.acceptedAt;
	}

	@action
	public async save(params: IProfileUpdate) {
		const response = await Api.Profile.save<IApiResponse<TResponse>>(params);
		this.performResponse(response.data);
	}

	@action
	public clearErrors() {
		this.error = "";
	}
}
